import { FileField, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

export type C18AudioAssetProps = RenderingProps<
  {
    Audio?: FileField;
    Caption?: RichTextField;
  },
  {
    CaptionPlacement?: string;
    PlayerAlignment?: string;
  } & TranslationOptionsParams &
    AnchorTargetParams
>;
